export default __webpack_public_path__ + "static/viinitie-banner-corporate-mobile.e45c3743cd695e96f434763f646255e8.webp";